// Utility functions for handling authenticated requests

/**
 * Get the stored JWT token from localStorage
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem('authToken');
};

/**
 * Remove the stored JWT token from localStorage
 */
export const clearAuthToken = (): void => {
  localStorage.removeItem('authToken');
};

/**
 * Create headers with Authorization token for authenticated requests
 */
export const getAuthHeaders = (): HeadersInit => {
  const token = getAuthToken();
  
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `${token}`;
  }

  return headers;
};


export const authenticatedFetch = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  const authHeaders = getAuthHeaders();
  
  const mergedOptions: RequestInit = {
    ...options,
    headers: {
      ...authHeaders,
      ...(options.headers || {}),
    },
  };

   const response = await fetch(url, mergedOptions);

   if (response.status === 401) {
    console.warn('Authentication failed (401). Token expired or invalid. Redirecting to home...');
    
    // Clear the expired/invalid token
    clearAuthToken();
    
    // Redirect to home page for re-authentication
    // Use setTimeout to allow redirect to complete smoothly
    setTimeout(() => {
      window.location.href = '/';
    }, 0);
    
    // Return a never-resolving promise to prevent further processing
    // This stops the error from propagating and showing the red error screen
    return new Promise<Response>(() => {});
  }

  return response;
};
